// extracted by mini-css-extract-plugin
export var button = "_ko-2";
export var card = "_ko-0";
export var closeButtonContainer = "_ko-3";
export var iconContainer = "_ko-1";